/* eslint-disable no-plusplus */
import { capitalize } from "lodash";

export const getIntervalNumber = (intervals, plans, subscription) => {
  if (subscription) {
    for (let i = 0; i < plans.length; i++) {
      const plan = plans[i];
      if (plan.planId === subscription.planId) {
        for (let j = 0; j < plan.cycles.length; j++) {
          const cycle = plan.cycles[j];
          if (cycle.cycleId === subscription.cycleId) {
            for (let k = 0; k < intervals.length; k++) {
              if (intervals[k] === cycle.pricingModel.frequencyType) {
                return k;
              }
            }
          }
        }
      }
    }
  }
  return 0;
}

export const getPricing = (userType, plans, frequencyType) => {
  let nonePrice = 'FREE';
  let basicPrice = 'FREE';
  let advancedPrice = 'FREE';
  let fullPrice = 'FREE';

  if (plans) {
    for (let i = 0; i < plans.length; i++) {
      const plan = plans[i];
      const planNames = plan.name.split(' - ');
      const iPlanType = planNames[0];
      const iPlanName = planNames[1];
      if (iPlanType.startsWith(userType)) {
        let price = 0;
        let formattedPrice;
        let interval;
        for (let j = 0; j < plan.cycles.length; j++) {
          const cycle = plan.cycles[j];
          if (cycle.visibility === 'Public' && cycle.pricingModel.frequencyType === frequencyType) {
            price = cycle.pricingModel.price;
            switch (cycle.pricingModel.frequencyType) {
              case 'Yearly':
                interval = 'year';
                break;
              case 'Weekly':
                interval = 'week';
                break;
              case 'Daily':
                interval = 'day';
                break;
              default:
                interval = 'month';
                break;
            }
            break;
          }
        }
        if (price === 0) {
          formattedPrice = 'FREE'
        } else {
          formattedPrice = `$${price / 100}/${interval}`;
        }
        if (iPlanName === "None") {
          nonePrice = formattedPrice;
        } else if (iPlanName === "Basic") {
          basicPrice = formattedPrice;
        } else if (iPlanName === "Advanced") {
          advancedPrice = formattedPrice;
        } else if (iPlanName === "Full") {
          fullPrice = formattedPrice;
        }
      }
    }
  }
  return {
    None: nonePrice,
    Basic: basicPrice,
    Advanced: advancedPrice,
    Full: fullPrice
  };
}

// Features available for each plan
export const features = [
  'ACE Contract Evaluation Software system',
  'Advanced Technical Support',
  'Basic Technical Support',
  // TODO 'Catalog Listings (FEDMALL)',
  // TODO 'Contract Mgmt/DIBBS RFQs/EDI',
  'Contract Mgmt/Internal RFQs',
  'Internal Messaging',
  'Inventory Management upload/search',
  'Procurement History Search',
  'Real Time Tooling Search ',
  'Request Tooling Location - Form Submit - Send email to: support@nffs.atlassian.net',
  'Solicitation view full details',
  'Solicitation bid matching to capabilities/tooling',
  'Supplier Capability DB Entry - Simple directory listing',
  'Supplier Capability DB entry - Enhanced directory listing',
];

export const planFeatures = {
  New: [],
  None: [
    'Request Tooling Location - Form Submit - Send email to: support@nffs.atlassian.net',
  ],
  Basic: [
    'Basic Technical Support',
    'Request Tooling Location - Form Submit - Send email to: support@nffs.atlassian.net',
    'Solicitation bid matching to capabilities/tooling',
    'Supplier Capability DB Entry - Simple directory listing',
  ],
  Advanced: [
    'Advanced Technical Support',
    'Basic Technical Support',
    'Contract Mgmt/Internal RFQs',
    'Internal Messaging',
    'Inventory Management upload/search',
    'Procurement History Search',
    'Real Time Tooling Search ',
    'Request Tooling Location - Form Submit - Send email to: support@nffs.atlassian.net',
    'Solicitation view full details',
    'Solicitation bid matching to capabilities/tooling',
    'Supplier Capability DB Entry - Simple directory listing',
    'Supplier Capability DB entry - Enhanced directory listing',
  ],
  Full: [
    'ACE Contract Evaluation Software system',
    'Advanced Technical Support',
    'Basic Technical Support',
    'Contract Mgmt/Internal RFQs',
    'Internal Messaging',
    'Inventory Management upload/search',
    'Procurement History Search',
    'Real Time Tooling Search ',
    'Request Tooling Location - Form Submit - Send email to: support@nffs.atlassian.net',
    'Solicitation view full details',
    'Solicitation bid matching to capabilities/tooling',
    'Supplier Capability DB Entry - Simple directory listing',
    'Supplier Capability DB entry - Enhanced directory listing',
  ]
};

export const valuePlan = plan => ['New', 'None', 'Basic', 'Advanced', 'Full'].indexOf(plan);

export const comparePlans = (planA, planB) => valuePlan(planA) - valuePlan(planB);

export const gainPlan = (planA, planB) => {
  const featuresA = planFeatures[planA];
  const featuresB = planFeatures[planB];
  const gained = [];
  featuresB.forEach(item => {
    if (!featuresA.includes(item)) {
      gained.push(item);
    }
  })
  return gained;
}

export const losePlan = (planA, planB) => {
  const featuresA = planFeatures[planA];
  const featuresB = planFeatures[planB];
  const lost = [];
  featuresA.forEach(item => {
    if (!featuresB.includes(item)) {
      lost.push(item);
    }
  })
  return lost;
}

// Get plan details from billsby:
export const getPlanDetails = (userType, planName, plans, frequencyType) => {
  let planId = 0;
  let cycleId = 0;
  let freeTrial = 0;
  let freeTrialFrequencyType = ''
  if (plans) {
    for (let i = 0; i < plans.length; i++) {
      const plan = plans[i];
      const planNames = plan.name.split(' - ');
      const iPlanType = planNames[0];
      const iPlanName = planNames[1];
      if (iPlanName === planName && iPlanType.startsWith(userType)) {
        planId = plan.planId;
        for (let j = 0; j < plan.cycles.length; j++) {
          const cycle = plan.cycles[j];
          if (cycle.visibility === 'Public' && cycle.pricingModel.frequencyType === frequencyType) {
            cycleId = cycle.cycleId;
            freeTrial = cycle.pricingModel.freeTrial;
            freeTrialFrequencyType = cycle.pricingModel.freeTrialFrequencyType;
            break;
          }
        }
        break;
      }
    }
  }
  let freeTrialPeriod = '';
  if (freeTrial) {
    freeTrialPeriod = freeTrial.toString();

    switch (freeTrialFrequencyType) {
      case 'Yearly':
        freeTrialPeriod += ' year';
        break;
      case 'Weekly':
        freeTrialPeriod += ' week';
        break;
      case 'Daily':
        freeTrialPeriod += ' day';
        break;
      default:
        freeTrialPeriod += ' month';
        break;
    }
  }

  return {
    name: planName,
    features: planFeatures[planName],
    planId,
    cycleId,
    freeTrialPeriod,
  };
}

export const getPlanName = (planId, plans) => {
  for (let i = 0; i < plans.length; i++) {
    const plan = plans[i];
    if (plan.planId === planId) {
      return plan.name;
    }
  }
  return '';
}

export const getCardTypeName = (cardType) => {
  const names = cardType.split('_');
  let cardTypeName = capitalize(names[0]);
  for (let i = 1; i < names.length; i++) {
    cardTypeName += ` ${capitalize(names[i])}`;
  }
  return cardTypeName;
}

// Return price associated with planId:
export const getPrice = (planId, cycleId, plans) => {
  let price = 0;
  for (let i = 0; i < plans.length; i++) {
    const plan = plans[i];
    if (plan.planId === planId) {
      for (let j = 0; j < plan.cycles.length; j++) {
        const cycle = plan.cycles[j];
        if (cycle.cycleId === cycleId) {
          price = cycle.pricingModel.price;
          break;
        }
      }
      break;
    }
  }
  return price;
}

// Use alternate cycleId for planData:
export const altPlanData = (planData, plans) => {
  for (let i = 0; i < plans.length; i++) {
    if (plans[i].planId === planData.planId) {
      for (let j = 0; j < plans[i].cycles.length; j++) {
        const cycle = plans[i].cycles[j];
        if (cycle.cycleId !== planData.cycleId &&
          cycle.visibility === 'Public' &&
          cycle.frequenceType === planData.frequencyType) {
          return { ...planData, cycleId: cycle.cycleId };
        }
      }
      return planData;
    }
  }
  return planData;
}

export const getUserType = (industryAssociations) => {
  let isAssociated = false;

  for (let i = 0; i < industryAssociations.length; i++) {
    if (industryAssociations[i].indexOf('*') < 0) {
      isAssociated = true;
    }
  }
  return isAssociated ? 'Associated' : 'Public';
}

export const getUserTypeA = (associationValidations) => {
  let isAssociated = false;

  if (associationValidations && associationValidations.length) {
    for (let i = 0; i < associationValidations.length; i++) {
      if (associationValidations[i].status === 'current' ||
        associationValidations[i].status === 'inheriting' ||
        associationValidations[i].status === 'grace_period'
      ) {
        isAssociated = true;
      }
    }
  }
  return isAssociated ? 'Associated' : 'Public';
}

export const displayAssociations = (associationValidations, sep = ', ') => {
  let result = '';
  if (associationValidations) {
    for (let i = 0; i < associationValidations.length; i++) {
      if (result !== '') {
        result += sep;
      }
      let annotation = '';
      let status = associationValidations[i].status;
      if (!status) {
        status = 'unknown'
      } else {
        status = status.replace('_', '-');
      }
      if (status === 'none' || status === 'unknown') {
        annotation = 'not validated'
      } else if (status !== 'current') {
        annotation = status;
      }
      if (annotation) {
        annotation = ` (${annotation})`
      }
      result += associationValidations[i].name + annotation;
    }
  }
  if (!result) {
    result = 'None';
  }
  return result;
}

export const isValidated = (associationValidations) => {
  let isAssociated = null;

  if (associationValidations) {
    for (let i = 0; i < associationValidations.length; i++) {
      if (associationValidations[i].status === 'current' ||
        associationValidations[i].status === 'inheriting' ||
        associationValidations[i].status === 'grace_period'
      ) {
        isAssociated = associationValidations[i].name;
        break;
      }
    }
  }
  return isAssociated;
}

export const compareAssoc = (newAssociationValidations, oldAssociationValidations) => {
  const newValid = isValidated(newAssociationValidations);
  const oldValid = isValidated(oldAssociationValidations);
  if (newValid && !oldValid) {
    return [1, newValid]
  }
  if (!newValid && oldValid) {
    return [-1, oldValid]
  }
  return [0, ''];
}

export default {
  getPricing,
  features,
  planFeatures,
  getPlanDetails,
  getUserType,
};



// WEBPACK FOOTER //
// ./src/components/Billsby/plans.js